/**
 * Kronstadt Filter Actions
 * Handles the "Speichern" button in the filter drawer.
 * Builds the filter URL from the form and dispatches facet:render
 * without auto-applying on every checkbox change.
 */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.kron-filter-btn--save');
  if (!btn) return;
  e.preventDefault();

  const form = document.getElementById('hdt-facet-filters-form');
  if (!form) return;

  const facetForm = form.closest('hdt-facet-filters-form');
  const sectionId = facetForm?.getAttribute('section-id');

  const params = new URLSearchParams(new FormData(form));
  const actionUrl = new URL(form.action);
  const url = new URL(actionUrl.origin + actionUrl.pathname);
  params.forEach((v, k) => url.searchParams.append(k, v));
  url.searchParams.delete('page');
  ['filter.v.price.gte', 'filter.v.price.lte'].forEach((k) => {
    if (url.searchParams.get(k) === '') url.searchParams.delete(k);
  });
  if (sectionId) url.searchParams.set('section_id', sectionId);

  form.dispatchEvent(
    new CustomEvent('facet:render', {
      bubbles: true,
      detail: { url },
    })
  );
});
